export enum AlertType {
	Info,
	Success,
	Error,
	Warning,
}
